import { Image, type ImageProps } from '../Image'
import { useCard } from './use-card'

export type BaseCardImageProps = Pick<ImageProps, 'alt' | 'loading' | 'position' | 'data-testid'> &
  Partial<Pick<ImageProps, 'ratio'>> &
  ({ src: string; srcSet?: never } | { src?: never; srcSet: string })

/**
 * Show a main Card image
 */
export const BaseCardImage = ({ ratio = '16:9', ...rest }: BaseCardImageProps) => {
  const { isMobile, hasHeader } = useCard()

  // reason: just three possible values
  // eslint-disable-next-line no-nested-ternary
  const mt = hasHeader ? (isMobile ? 2 : 0) : 0

  return <Image ratio={ratio} {...rest} sx={{ mt }} />
}
